import { FleetVehicleStatusEnum } from "services/api/fleet/vehicles/types";

/** Kratko objašnjenje statusa ispod naziva, da se zna što koji status znači. */
export const VEHICLE_STATUS_DESCRIPTIONS: Record<FleetVehicleStatusEnum, string> = {
  [FleetVehicleStatusEnum.ARRIVING]: "Vozilo je kupljeno i stiže u vozni park",
  [FleetVehicleStatusEnum.AVAILABLE]: "Vozilo je spremno za prodaju ili najam",
  [FleetVehicleStatusEnum.RESERVED]: "Vozilo je rezervirano za kupca",
  [FleetVehicleStatusEnum.ACTIVE]: "Vozilo je u upotrebi",
  [FleetVehicleStatusEnum.ACTIVE_RENTAL]: "Vozilo je kod klijenta u najmu",
  [FleetVehicleStatusEnum.ACTIVE_INTERNAL]: "Vozilo koristi tvrtka",
  [FleetVehicleStatusEnum.UNAVAILABLE]: "Vozilo se trenutno ne može koristiti",
  [FleetVehicleStatusEnum.UNAVAILABLE_SERVICE]: "Vozilo je na servisu",
  [FleetVehicleStatusEnum.UNAVAILABLE_DAMAGE]: "Vozilo čeka popravak štete",
  [FleetVehicleStatusEnum.UNAVAILABLE_DOCUMENTATION]: "Vozilu nedostaju papiri",
  [FleetVehicleStatusEnum.SOLD]: "Vozilo je prodano i izlazi iz voznog parka",
};
